var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FFC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77387 6.66956H8.77556L8.75869 6.74269L8.61244 7.43287H8.59556L7.632 11.5312H6.40631L7.389 7.43287H5.73975L4.81387 11.5312H3.46613L4.69125 6.46875H8.81606L8.77387 6.66956ZM11.1032 6.46875H13.1451C14.9017 6.54919 14.7381 7.71412 14.7381 7.71412H15.1875L15.0244 8.19619H14.6154C14.4934 8.63831 13.6761 8.87963 13.6761 8.87963C14.6154 9 14.5749 9.72337 14.5749 9.72337H15.0244L14.9018 10.2054H14.5339C14.4399 10.8748 13.8465 11.1999 13.3588 11.3546C13.0639 11.4467 12.7565 11.4928 12.4476 11.4913H9.8775L11.1032 6.46875ZM4.11919 7.43287H2.8125L3.05775 6.46875H4.36444L4.11919 7.43287ZM9.71494 10.9688L8.65294 8.47744L9.10237 6.54919L10.1638 8.91956L9.71494 10.9688ZM12.8391 8.47744C12.9853 8.47744 13.1259 8.42119 13.2289 8.31881C13.3318 8.21644 13.3903 8.07919 13.3903 7.93519C13.3903 7.79119 13.3324 7.65338 13.2289 7.55156C13.1254 7.44975 12.9853 7.39294 12.8391 7.39294H12.0431L11.7984 8.47744H12.8391ZM12.564 10.5671C12.9302 10.5671 13.2272 10.2881 13.2272 9.94444C13.2272 9.60019 12.9319 9.32119 12.564 9.32119H11.6066L11.3119 10.5671H12.564Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnb);
export default __webpack_public_path__ + "static/media/tnb.403d672911291e0dc4ced4262cc31e59.svg";
export { ForwardRef as ReactComponent };